import { gsap } from 'gsap';

class KeyMomentsSlider {
  constructor() {
    this.container = document.querySelector('.ns-key-moments__slider');
    if (!this.container) return;

    this.slides = [...this.container.querySelectorAll('.ns-key-moment')];
    this.currentIndex = 0;
    this.isAnimating = false;

    this.isDragging = false;
    this.startPos = 0;
    this.currentTranslate = 0;
    this.prevTranslate = 0;
    this.dragThreshold = 100;

    this.createPagination();
    this.updateSlideClasses();

    this.slides.forEach((slide, index) => {
      const className = index % 2 === 0 ? 'ns-polygon-01' : 'ns-polygon-02';
      slide.classList.add(className);
    });

    this.container.querySelector('.slider-button--next').addEventListener('click', () => this.animateSlideTransition(this.slides[this.currentIndex], 'next'));
    this.container.querySelector('.slider-button--prev').addEventListener('click', () => this.animateSlideTransition(this.slides[this.currentIndex], 'prev'));

    this.initTouchEvents();
  }

  createPagination() {
    const paginationContainer = document.createElement('div');
    paginationContainer.className = 'ns-key-moments__pagination';

    this.slides.forEach((slide, index) => {
      const dot = document.createElement('button');
      dot.className = 'pagination-dot';
      dot.setAttribute('aria-label', `Slide ${index + 1}`);

      dot.addEventListener('click', () => {
        if (this.isAnimating || index === this.currentIndex) return;

        const direction = index > this.currentIndex ? 'next' : 'prev';
        const currentSlide = this.slides[this.currentIndex];

        const targetIndex = index;

        this.animateSlideTransition(currentSlide, direction);

        setTimeout(() => {
          this.currentIndex = targetIndex;
          this.updatePagination();
          this.updateSlideClasses();
        }, 100);
      });

      paginationContainer.appendChild(dot);
    });

    this.container.appendChild(paginationContainer);
    this.paginationDots = paginationContainer.querySelectorAll('.pagination-dot');
    this.updatePagination();
  }

  updatePagination() {
    this.paginationDots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === this.currentIndex);
    });
  }

  updateSlideClasses() {
    this.slides.forEach((slide, index) => {
      slide.classList.remove('is-prev', 'is-active', 'is-next', 'is-soon-active', 'is-ending-prev', 'is-ending-next', 'is-ending');

      setTimeout(() => {
        this.container.classList.remove('is-animating');
      }, 100);

      if (index === this.getPrevIndex()) slide.classList.add('is-prev');
      if (index === this.currentIndex) slide.classList.add('is-active');
      if (index === this.getNextIndex()) slide.classList.add('is-next');
    });
  }

  updateNextClass() {
    this.slides.forEach((slide, index) => {
      slide.style.zIndex = 0;
      if (index === this.getNextIndex()) slide.style.zIndex = 1;
    });
  }

  updatePrevClass() {
    this.slides.forEach((slide, index) => {
      slide.style.zIndex = 0;
      if (index === this.getPrevIndex()) slide.style.zIndex = 1;
    });
  }

  getPrevIndex() {
    return this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
  }

  getNextIndex() {
    return this.currentIndex === this.slides.length - 1 ? 0 : this.currentIndex + 1;
  }

  animateSlideTransition(animateSlide, direction) {
    if (this.isAnimating) {
      return;
    }

    this.isAnimating = true;
    this.container.classList.add('is-animating');

    let prevIndex = 0;
    let nextIndex = 0;

    const oldSlide = this.slides[this.currentIndex];
    oldSlide.classList.add('is-ending', `is-ending-${direction}`);

    if(direction == 'prev') {
      prevIndex = this.getPrevIndex();
      this.updatePrevClass();
      this.currentIndex = prevIndex;
    } else if(direction == 'next') {
      nextIndex = this.getNextIndex();
      this.updateNextClass();
      this.currentIndex = nextIndex;
    }

    const currentSlide = this.slides[this.currentIndex];
    currentSlide.classList.add('is-soon-active');

    this.updatePagination();

    let animateSlidePolygon = animateSlide.querySelector('.ns-key-moment__polygon-wrapper');
    let animateSlidePolygonAfter = currentSlide.querySelector('.ns-key-moment__polygon--after');
    let animateSlidePolygonBefore = animateSlide.querySelector('.ns-key-moment__polygon--after');

    const tl = gsap.timeline({
      onComplete: () => {
        this.isAnimating = false;
        animateSlidePolygon.style.clipPath = 'none';
        this.updateSlideClasses();
      }
    });

    const tl2 = gsap.timeline({
      onComplete: () => {
        this.isAnimating = false;
      }
    });

    if(window.innerWidth > 992) {
      if(direction == 'prev') {
        if(currentSlide.classList.contains('ns-polygon-01')){
          animateSlidePolygonAfter.style.clipPath = 'none';
          tl.set(animateSlidePolygon, {
            clipPath: 'polygon(30% 100%, 100% 100%, 100% 0%, 80% 0, 50% 30%)'
          }).to(animateSlidePolygon, {
            clipPath: 'polygon(100% 100%, 100% 100%, 100% 0%, 80% 0, 50% 30%)',
            duration: .2,
            ease: "power1.in"
          }).to(animateSlidePolygon, {
            clipPath: 'polygon(100% 0%, 100% 0%, 100% 0%, 80% 0%, 50% 30%)',
            duration: .2,
            ease: "none"
          }).to(animateSlidePolygon, {
            clipPath: 'polygon(80% 0%, 80% 0%, 80% 0%, 80% 0%, 50% 30%)',
            duration: .2,
            ease: "power1.out"
          });
          tl2.set(animateSlidePolygonAfter, {
            clipPath: 'polygon(30% 100%, 100% 100%, 100% 0%, 80% 0, 50% 30%)'
          }).to(animateSlidePolygonAfter, {
            clipPath: 'polygon(40% 100%, 100% 100%, 100% 0%, 80% 0, 50% 30%)',
            delay: .45,
            duration: .2,
            ease: "power1.out"
          });
        } else {
          tl.set(animateSlidePolygon, {
            clipPath: 'polygon(30% 100%, 100% 100%, 100% 0%, 80% 0, 50% 30%)'
          }).to(animateSlidePolygon, {
            clipPath: 'polygon(100% 100%, 100% 100%, 100% 0%, 80% 0, 50% 30%)',
            duration: .1,
            ease: "power1.in"
          }).to(animateSlidePolygon, {
            clipPath: 'polygon(100% 0%, 100% 0%, 100% 0%, 80% 0%, 50% 30%)',
            duration: .2,
            ease: "none"
          }).to(animateSlidePolygon, {
            clipPath: 'polygon(80% 0%, 80% 0%, 80% 0%, 80% 0%, 50% 30%)',
            duration: .2,
            ease: "power1.out"
          });
        }
      } else if(direction == 'next') {
          if(currentSlide.classList.contains('ns-polygon-01')){
            let variant = 'polygon(30% 100%, 30% 100%, 30% 100%, 30% 100%, 50% 30%)';
            let variant2 = 'polygon(30% 100%, 40% 100%, 40% 100%, 40% 100%, 50% 30%)';

            tl.set(animateSlidePolygon, {
              clipPath: 'polygon(30% 100%, 100% 100%, 100% 0%, 80% 0, 50% 30%)'
            }).to(animateSlidePolygon, {
              clipPath: 'polygon(30% 100%, 100% 100%, 100% 0%, 100% 0, 50% 30%)',
              duration: .1,
              ease: "power1.in"
            }).to(animateSlidePolygon, {
              clipPath: 'polygon(30% 100%, 100% 100%, 100% 100%, 100% 100%, 50% 30%)',
              duration: .2,
              ease: "none"
            }).to(animateSlidePolygon, {
              clipPath: 'polygon(30% 100%, 40% 100%, 40% 100%, 40% 100%, 50% 30%)',
              duration: .2,
              ease: "power1.out"
            });
          } else {
            tl.set(animateSlidePolygon, {
              clipPath: 'polygon(30% 100%, 100% 100%, 100% 0%, 80% 0, 50% 30%)'
            }).to(animateSlidePolygon, {
              clipPath: 'polygon(30% 100%, 100% 100%, 100% 0%, 100% 0, 50% 30%)',
              duration: .1,
              ease: "power1.in"
            }).to(animateSlidePolygon, {
              clipPath: 'polygon(30% 100%, 100% 100%, 100% 100%, 100% 100%, 50% 30%)',
              duration: .2,
              ease: "none"
            }).to(animateSlidePolygon, {
              clipPath: 'polygon(30% 100%, 30% 100%, 30% 100%, 30% 100%, 50% 30%)',
              duration: .2,
              ease: "power1.out"
            });
              tl2.set(animateSlidePolygonBefore, {
              clipPath: 'polygon(40% 100%, 100% 100%, 100% 0%, 80% 0, 50% 30%)'
            }).to(animateSlidePolygonBefore, {
              clipPath: 'polygon(30% 100%, 100% 100%, 100% 0%, 80% 0, 50% 30%)',
              duration: .2,
              ease: "power1.in"
            }).to(animateSlidePolygonBefore, {
              clipPath: 'polygon(40% 100%, 100% 100%, 100% 0%, 80% 0, 50% 30%)',
                delay: .4,
              duration: .2,
              ease: "power1.out"
            });
          }
       }
    } else {
      if(direction == 'prev') {
        tl.set(animateSlidePolygon, {
          clipPath: 'polygon(100% 0%, 10% 40%, -30% 100%,100% 100%)'
        }).to(animateSlidePolygon, {
          clipPath: 'polygon(100% 100%, 10% 40%, -30% 100%,100% 100%)',
          duration: .1,
          ease: "power1.in"
        }).to(animateSlidePolygon, {
          clipPath: 'polygon(-30% 100%, 10% 40%,-30% 100%,-30% 100%)',
          duration: .2,
          ease: "power1.out"
        });
      } else if(direction == 'next') {
          tl.set(animateSlidePolygon, {
            clipPath: 'polygon(100% 0%, 10% 40%, -30% 100%,100% 100%)'
          }).to(animateSlidePolygon, {
            clipPath: 'polygon(100% 0%, 10% 40%, 100% 100%,100% 100%)',
            duration: .1,
            ease: "power1.in"
          }).to(animateSlidePolygon, {
            clipPath: 'polygon(100% 0%, 10% 40%, 100% 0%,100% 0%)',
            duration: .2,
            ease: "power1.out"
          });
       }
    }
  }

  initTouchEvents() {
    this.container.addEventListener('touchstart', (e) => this.handleDragStart(e));
    this.container.addEventListener('touchmove', (e) => this.handleDragMove(e));
    this.container.addEventListener('touchend', (e) => this.handleDragEnd(e));

    this.container.addEventListener('mousedown', (e) => this.handleDragStart(e));
    this.container.addEventListener('mousemove', (e) => this.handleDragMove(e));
    this.container.addEventListener('mouseup', (e) => this.handleDragEnd(e));
    this.container.addEventListener('mouseleave', (e) => this.handleDragEnd(e));

    this.container.addEventListener('contextmenu', e => e.preventDefault());
  }

  handleDragStart(e) {
    if (this.isAnimating) return;

    this.isDragging = true;
    this.startPos = this.getPositionX(e);

    this.container.style.cursor = 'grabbing';
  }

  handleDragMove(e) {
    if (!this.isDragging) return;

    const currentPosition = this.getPositionX(e);
    this.currentTranslate = currentPosition - this.startPos;
  }

  handleDragEnd(e) {
    if (!this.isDragging) return;

    this.isDragging = false;
    this.container.style.cursor = 'grab';

    if (Math.abs(this.currentTranslate) > this.dragThreshold) {
      if (this.currentTranslate > 0) {
        this.animateSlideTransition(this.slides[this.currentIndex], 'prev');
      } else {
        this.animateSlideTransition(this.slides[this.currentIndex], 'next');
      }
    }

    this.currentTranslate = 0;
    this.startPos = 0;
  }

  getPositionX(e) {
    return e.type.includes('mouse')
      ? e.pageX
      : e.touches[0].clientX;
  }
} export default KeyMomentsSlider;
